export default __webpack_public_path__ + "static/media/shutterstock_152507294.280c9764.png";